<template>
  <Item
    tag="router-link"
    :to="{ name: 'form-submit-mutate', params: { id: value.id } }"
    :type="value.typename.toLowerCase()"
    :title="`${$t('new')} ${$tc('inquiry', 1).toLowerCase()}`"
  >
    <template #datetime>
      <FontAwesomeIcon :icon="['fal', 'calendar']" style="margin-right: 3px" />
      {{ value.createdAt | Moment('DD. MMM [kl.] HH.mm') }}
    </template>
    <template #type> {{ value.form.title }}</template>
  </Item>
</template>

<script>
import Item from '@/components/ListItem'
import { Moment } from '@/filters'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  filters: {
    Moment,
  },
  components: {
    Item,
  },
}
</script>

<style lang="scss">
.list-item--lead {
  a {
    text-decoration: none;
  }
}
</style>
